import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FuseSharedModule } from '@fuse/shared.module';
import { ComponentsModule } from '../../components/components.module';
import { DirectivesModule } from '../../directives/directives.module';
import { CuttingButtFormService } from '../../services/cutting-butt-form.service';
import { EdgesInColorComponent } from '../edge-in-color/edges-in-color.component';
import { MaterialBaseButtsDialogModule } from '../material-base-butts-dialog/material-base-butts-dialog.module';
import { EdgesInColorDialogComponent } from './edges-in-color-dialog.component';

@NgModule({
  declarations: [EdgesInColorDialogComponent],
  imports: [
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatCheckboxModule,
    MatTooltipModule,

    FuseSharedModule,
    ComponentsModule,
    DirectivesModule,
    MaterialBaseButtsDialogModule,
    EdgesInColorComponent,
  ],
  providers: [CuttingButtFormService],
  exports: [EdgesInColorDialogComponent],
})
export class EdgesInColorDialogModule {}
